import React from 'react';
import { Gauge } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';

/**
 * Placeholder for execution-quality analytics (entry/exit slippage by broker,
 * SL chase drift, partial-fill rate). Backend data is available — see
 * average_entry_price vs expected_entry_price, sl_average_price vs
 * sl_trigger_price on the positions row. Wire up the panels here as a
 * follow-up to the left-rail restructure.
 */
const ExecutionSection: React.FC = () => (
  <Card>
    <CardContent className="py-16 flex flex-col items-center text-center gap-3">
      <div className="h-12 w-12 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center">
        <Gauge className="h-6 w-6 text-blue-600 dark:text-blue-400" />
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-900 dark:text-white">Execution Quality — coming soon</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 max-w-md mt-1">
          Entry / exit slippage, SL chase drift, partial-fill rate per broker.
          Data already lives on every closed position; this view will surface it.
        </p>
      </div>
    </CardContent>
  </Card>
);

export default ExecutionSection;
